import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import ControlWithLabel from 'src/components/ControlWithLabel';
import PageFooter from 'src/components/PageFooter';
import PageHeader from 'src/components/PageHeader';
import StyledLinearProgressBar from 'src/components/StyledLinearProgressBar';
import TermsAndConditionsContent from 'src/components/TermsAndConditionsContent';
import { useOnboardingWorkflow } from 'src/contexts/OnboardingWorkflowContext';
import { selectHasAcceptedTerms, setHasAcceptedTerms } from 'src/store/slices/onboardingSlice';
import { useAppDispatch } from 'src/store/store';

export const Route = createFileRoute('/(app)/onboarding/terms')({
    component: TermsComponent,
});

function TermsComponent() {
    const dispatch = useAppDispatch();
    const { progress, nextStep, previousStep, canGoBack } = useOnboardingWorkflow();

    const hasAcceptedTerms = useSelector(selectHasAcceptedTerms);
    const [acceptedTermsLocal, setAcceptedTermsLocal] = useState<boolean>(hasAcceptedTerms);

    const handleContinue = () => {
        dispatch(setHasAcceptedTerms(acceptedTermsLocal));
        nextStep();
    };

    return (
        <>
            <PageHeader
                hideBackButton={!canGoBack}
                onBack={canGoBack ? previousStep : undefined}
                hideActionButton
            >
                <StyledLinearProgressBar value={progress.percentage} />
            </PageHeader>
            <Stack sx={{ gap: 2, pb: 4 }}>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                    Please review our Terms & Conditions
                </Typography>

                <TermsAndConditionsContent />

                <ControlWithLabel
                    label="I have read and agree to the Terms of Service, Privacy Policy, and Health Data Privacy Policy."
                    checked={acceptedTermsLocal || false}
                    onChange={() => setAcceptedTermsLocal(!acceptedTermsLocal)}
                />
            </Stack>
            <PageFooter>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={!acceptedTermsLocal}
                    onClick={handleContinue}
                >
                    Continue
                </Button>
            </PageFooter>
        </>
    );
}
